import React from 'react';

const TagIcon = ({ fill = "currentColor", width = "24", height = "24" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M3 6.2V9.68C3 10.05 3 10.24 3.04 10.41C3.08 10.57 3.15 10.72 3.24 10.85C3.34 11 3.48 11.13 3.75 11.4L11.31 18.96C12.24 19.89 12.71 20.35 13.24 20.53C13.71 20.68 14.21 20.68 14.68 20.53C15.21 20.35 15.68 19.89 16.61 18.96L18.96 16.61C19.89 15.68 20.35 15.21 20.53 14.68C20.68 14.21 20.68 13.71 20.53 13.24C20.35 12.71 19.89 12.24 18.96 11.31L11.4 3.75C11.13 3.48 11 3.34 10.85 3.24C10.72 3.15 10.57 3.08 10.41 3.04C10.24 3 10.05 3 9.68 3H6.2C5.08 3 4.52 3 4.09 3.22C3.72 3.41 3.41 3.72 3.22 4.09C3 4.52 3 5.08 3 6.2Z" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 7.5H7.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default TagIcon;
